/**
 * @from weberus/packages/feature-flag
 */
import { createContext } from 'react'

import { FeatureFlagService } from './feature-flag-service'

import type { EnvConfig, FeatureFlagEnv } from './feature-flag-service'

export const FeatureFlagContext = createContext<FeatureFlagService<string> | null>(null)

/**
 * feature flag 관리를 위한 컨텍스트를 제공하는 컴포넌트입니다.
 *
 * @component
 * @param {React.ReactNode} props.children
 * @param {Record<string, EnvConfig>} props.featureFlagsConfig - 환경별 feature flag 설정을 나타내는 객체입니다.
 * @param {FeatureFlagEnv} props.featureFlagEnv - 현재 환경을 나타내는 문자열 입니다. ("dev" | "qa" | "stage" | "prod")
 *
 * @example
 * <FeatureFlagProvider featureFlagsConfig={featureFlagsConfig} featureFlagEnv={process.env.NEXT_PUBLIC_SERVICE_ENV}>
 *   <MyComponent />
 * </FeatureFlagProvider>
 */
export const FeatureFlagProvider: React.FC<{
  children: React.ReactNode
  featureFlagsConfig: Record<string, EnvConfig>
  featureFlagEnv: FeatureFlagEnv
}> = ({ children, featureFlagsConfig, featureFlagEnv }) => {
  const featureFlagService = new FeatureFlagService(featureFlagsConfig, featureFlagEnv)

  return (
    <FeatureFlagContext.Provider value={featureFlagService}>{children}</FeatureFlagContext.Provider>
  )
}
